import { MATCH_PROVENANCE_TEXT_KEY } from '../RentalPortalMatchProvenanceDot'

export const MATCH_PROVENANCE_LEGEND_ITEMS = [
  { labelKey: MATCH_PROVENANCE_TEXT_KEY.applicant, source: 'applicant' },
  { labelKey: MATCH_PROVENANCE_TEXT_KEY.manual, source: 'manual' },
  {
    labelKey: MATCH_PROVENANCE_TEXT_KEY.greta_message,
    source: 'greta_message',
  },
]
